module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_path.js
// module id = 374
// module chunks = 220